import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=0cba806f&"
import script from "./Drawer.vue?vue&type=script&lang=ts&"
export * from "./Drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cba806f')) {
      api.createRecord('0cba806f', component.options)
    } else {
      api.reload('0cba806f', component.options)
    }
    module.hot.accept("./Drawer.vue?vue&type=template&id=0cba806f&", function () {
      api.rerender('0cba806f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drawer/Drawer.vue"
export default component.exports